import script from "./Mobile.vue?vue&type=script&setup=true&lang=js"
export * from "./Mobile.vue?vue&type=script&setup=true&lang=js"

import "./Mobile.vue?vue&type=style&index=0&id=76bce605&lang=scss&scoped=true"

import exportComponent from "H:\\project\\tako\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76bce605"]])

export default __exports__